import { Colors, FlexBox, useBreakpoint, useIsMobile } from "@brg/ui";
import React, { FC, useCallback, useMemo, useState } from "react";
import { WrappedFieldProps } from "redux-form";
import { ProjectEditPageGridInput } from "../../../../../../_deziiign/books/pages/BookEdit/styles";
import { Input } from "@brg/input";
import { AddButton, ProjectEditPageGridRow } from "../../../../projectEdit/styles";
import { TextAreaLengthCounter } from "../../../components/TextAreaLengthCounter";
import { DefaultButton, TeamEditLabel } from "../../../styles";
import { GridRow } from "../../../../CompetitionApplicationForm/components/styles";
import { FormLabel, FormLabelText } from "../../../../../modals/styles";
import { LabelRedStar } from "../../../../designerEditView/styles";
import styled from "styled-components";
import { LayoutConst } from "core";
import { InfoIcon } from "shared/components/InfoIcon/InfoIcon";
import { ProjectAddButton } from "shared/pages/projectEdit/ProjectAddButton";
import { useRouteMatch } from "react-router-dom";
import { Utils } from "shared/helpers/utils/utils";

export const InputContainer = styled(FlexBox)`
  width: 610px;
  position: relative;
  
  .text {
      font-size: 17px;
      line-height: 22px;
      font-weight: 400;
      color: #909090;
  }

  .brg-input__value-container {
      height: 100%;
  }
  
  .phone-input-button {
      border: none;
  }
  
  .checkbox-with-label {
      div:last-child {
          white-space: nowrap;
          color: rgba(144, 144, 144, 1);
          font-size: 17px;
          line-height: 22px;
          font-weight: 400;
      }

      div {
          min-width: auto;
      }
  }
  
      .brg-input__control--menu-is-open {
          .brg-input__value-container {
              height: auto;
          }
      }
          
      .brg-input__control {
          background-color: rgba(242, 242, 242, 1) !important;
          border-color: transparent !important;
  
              .brg-input__placeholder {
                  color: #909090;
              }
              &:focus {
                  border-color: #30363A;
                  .brg-input__placeholder {
                      color: #909090;
                  }
              }
              &:active {
                  border-color: #30363A;
                  .brg-input__placeholder {
                      color: #909090;
                  }
              }
              &:hover {
                  border-color: #30363A;
                  .brg-input__placeholder {
                      color: #909090 !important;
                  }
              }
  
      }
  
      .brg-input__multi-value__label, .brg-input__single-value  {
          color: #151514 !important;
      }
  
      .brg-input__multi-value {
          background-color: transparent;
          padding-top: 8px;
          svg path {
              fill: #151514;
              cursor: pointer;
          }
      }
  
      .brg-input__multi-value__remove {
          cursor: pointer;
          &:hover {
              background-color: transparent;
          }
      }
  
      .brg-input__menu-list {
          &::-webkit-scrollbar {
            height: 1px;
            width: 2px;
          }
          &::-webkit-scrollbar-track {
            border-radius: 10px;
            background: ${({theme}) => theme.competition.input.bgActive} !important;
          }
          &::-webkit-scrollbar-thumb {
            background: ${({theme}) => theme.competition.input.inputText} !important;
          }
        }
      
        .brg-input__menu {
          background-color: ${({theme}) => theme.competition.input.bg} !important;
      
          .brg-input__option {
            cursor: pointer;
            color: ${({theme}) => theme.competition.input.inputText} !important;
            svg {
              path {
                fill: ${({theme}) => theme.competition.input.inputText} !important;
              }
            }
          }
          .brg-input__option--is-focused {
            background-color: ${({theme}) => theme.competition.input.bgActive} !important;
          }
          .brg-input__option--is-focused:hover {
            background-color: ${({theme}) => theme.competition.input.bgActive} !important;
          }
        }
  
        .brg-input__indicators {
          align-items: start;
        }
        
        .brg-input__indicator {
          padding-top: 14px;
          margin-right: 0;
          svg {
            path {
              fill: ${({theme}) => theme.competition.input.inputText} !important;;
            }
          }
        }
  
      input {
          &:disabled {
              color: #909090 !important;
          }
      }
  
      input, textarea {
          background-color: ${Colors.galBlack5} !important;
          border-color: transparent !important;
          color: ${Colors.galBlack47} !important;
          font-size: 15px;
          line-height: 20px;
  
          &:hover {
              border-color: transparent !important;
          }
  
          &::placeholder {
              color: ${Colors.galBlack47} !important;
          }
      }
  
  
      textarea {
          width: 100%;
          min-height: 73px;
          font-family: 'Inter';
          font-style: normal;
          font-weight: 400;
          font-size: 15px !important;
          line-height: 20px !important;
          letter-spacing: -0.02em  !important;
          padding: 16px 45px 21px 24px;
          color: #151514 !important;
          &::-webkit-scrollbar {
              height: 1px;
              width: 2px;
            }
            &::-webkit-scrollbar-track {
              border-radius: 10px;
              background-color: transparent;
            }
            &::-webkit-scrollbar-thumb {
              background-color: ${({ theme }) => theme.app?.backgroundColor === '#FEFEFE' ? `${Colors.geoWhite47}` : `${Colors.geoWhite100}`};
            }
      }
  
      input {
          height: 48px !important;
          width: 100%;
          font-family: 'Inter';
          font-style: normal;
          font-weight: 400;
          font-size: 15px;
          line-height: 20px;
          letter-spacing: -0.02em;
          color: #151514 !important;
      }

          @media(max-width: ${LayoutConst.screen.md}px) {

          }
  
          @media(max-width: ${LayoutConst.screen.s}px) {
              width: 100%;
              max-width: 100%;
              min-width: 100%;
              input {
                  height: 48px !important;
                width: 100%;
                max-width: 100%;
                min-width: 100%;
              }

              textarea {
                width: 100%;
                max-width: 100%;
                min-width: 100%;
              }
  
              button {
                  font-size: 13px;
                  line-height: 16px;
              }
  
            }
   
      @media(max-width: ${LayoutConst.screen.md}px) {
          input {
              height: 40px !important;
          }
      }
  
      @media(max-width: ${LayoutConst.screen.s}px) {
          input {
              height: 48px !important;
          }
      }
`;

const DEFAULT_VALUE = {
  value: '',
  index: 0
}

interface BilingualTextInputProps extends WrappedFieldProps {
  label: string;
  required?: boolean;
  multiline?: boolean;
  maxLength?: number;
  multipleValues?: boolean;
  hint?: string;
  placeholder: string;
  defaultValue?: string;
  style?: React.CSSProperties;
}

const BaseInput: FC<{
  value: any, 
  onChange: (val: any) => void, 
  placeholder: string, 
  maxLength?: number, 
  required?: boolean
}> = ({ 
  value, 
  onChange, 
  placeholder, 
  maxLength, 
  required 
}) => {

  return (
      <Input.Text
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        maxLength={maxLength}
        required={required}
      />
    )
}

const TextInput: FC<BilingualTextInputProps> = ({
  input,
  input: {
    onChange,
    value: inputValue,
  },
  meta: {
    touched,
    error,
  },
  hint,
  label,
  required,
  multiline,
  multipleValues,
  maxLength,
  placeholder,
  defaultValue,
  style,
  ...rest
}) => {
  const isMobile = useIsMobile();
  const isCompetition = !!useRouteMatch('/competition');
  const [multipleValueIdx, setMultipleValueIdx] = useState([
    {
      value: '',
      index: 0
    }
  ]);

  const handleChange = useCallback(({ target: { value } }: React.BaseSyntheticEvent, index?: number) => {
    const convertValue = value.trimLeft();

    if (multipleValues && Utils.isNumber(index)) {
      const data = [...multipleValueIdx]
      data[index] = {
        index,
        value: convertValue
      }

      setMultipleValueIdx(data);
      onChange(data?.map((v) => v?.value));
      return;
    }

    onChange(convertValue);
  }, [inputValue, multipleValueIdx, multipleValues]);

  const renderInputs = () => {
    return multipleValueIdx?.map((input, index) => {
      return (
        <BaseInput 
          value={input?.value}
          onChange={(ev) => handleChange(ev, index)}
          placeholder={placeholder}
          maxLength={maxLength}
          required={required}
        />
      )
    })
  }

  const multipleValuesComponent = useMemo(() => {
    return (
      <FlexBox 
        direction="column" 
        directionMobile="column" 
        gy={16} 
        offsetBottom={multipleValueIdx?.length > 1 ? 24 : 1}
      >
        {renderInputs()}
        {multipleValueIdx?.length < 3 && (
          <ProjectAddButton
            text={''}
            onClick={() => {
              if (multipleValueIdx?.length < 3) {
                setMultipleValueIdx(
                  [
                    ...multipleValueIdx, 
                    {
                      ...DEFAULT_VALUE, 
                      index: multipleValueIdx?.length + 1
                    }
                  ]
                )
              }
            }} 
          />
        )}
      </FlexBox>
    )
  } , [multipleValueIdx])

  return (
    <GridRow isTeamEdit>
      <FormLabel isTeamEdit>
        <FormLabelText required={isCompetition && required}>{label}</FormLabelText>
        {hint && (
          <InfoIcon stc={isCompetition} isCompetition={isCompetition} msg={hint}/>
        )}
        {required && !isCompetition && (
          <LabelRedStar>*</LabelRedStar>
        )}
      </FormLabel>
      <InputContainer className="input-container" direction="column" directionMobile="column">

        {multipleValues ? multipleValuesComponent : multiline ?
          (
            <>
              <Input.Textarea
                maxLength={maxLength}
                value={defaultValue || inputValue}
                onChange={handleChange}
                style={style}
                placeholder={placeholder}
                required={required}
              />
              <TextAreaLengthCounter 
                value={inputValue?.length}
                pos={{ bottom: 8, right: isMobile ? 16 : 8 }}
                maxLength={maxLength}
              />
            </>
          ) : (
            <Input.Text
              value={defaultValue || inputValue}
              onChange={handleChange}
              placeholder={placeholder}
              maxLength={maxLength}
              required={required}
            />
          )}
      </InputContainer>
    </GridRow>
  )
}

export default TextInput;import { Colors, FlexBox, useBreakpoint, useIsMobile } from "@brg/ui";
import React, { FC, useCallback, useMemo, useState } from "react";
import { WrappedFieldProps } from "redux-form";
import { ProjectEditPageGridInput } from "../../../../../../_deziiign/books/pages/BookEdit/styles";
import { Input } from "@brg/input";
import { AddButton, ProjectEditPageGridRow } from "../../../../projectEdit/styles";
import { TextAreaLengthCounter } from "../../../components/TextAreaLengthCounter";
import { DefaultButton, TeamEditLabel } from "../../../styles";
import { GridRow } from "../../../../CompetitionApplicationForm/components/styles";
import { FormLabel, FormLabelText } from "../../../../../modals/styles";
import { LabelRedStar } from "../../../../designerEditView/styles";
import styled from "styled-components";
import { LayoutConst } from "core";
import { InfoIcon } from "shared/components/InfoIcon/InfoIcon";
import { ProjectAddButton } from "shared/pages/projectEdit/ProjectAddButton";
import { useRouteMatch } from "react-router-dom";
import { Utils } from "shared/helpers/utils/utils";

export const InputContainer = styled(FlexBox)`
  width: 610px;
  position: relative;
  
  .text {
      font-size: 17px;
      line-height: 22px;
      font-weight: 400;
      color: #909090;
  }

  .brg-input__value-container {
      height: 100%;
  }
  
  .phone-input-button {
      border: none;
  }
  
  .checkbox-with-label {
      div:last-child {
          white-space: nowrap;
          color: rgba(144, 144, 144, 1);
          font-size: 17px;
          line-height: 22px;
          font-weight: 400;
      }

      div {
          min-width: auto;
      }
  }
  
      .brg-input__control--menu-is-open {
          .brg-input__value-container {
              height: auto;
          }
      }
          
      .brg-input__control {
          background-color: rgba(242, 242, 242, 1) !important;
          border-color: transparent !important;
  
              .brg-input__placeholder {
                  color: #909090;
              }
              &:focus {
                  border-color: #30363A;
                  .brg-input__placeholder {
                      color: #909090;
                  }
              }
              &:active {
                  border-color: #30363A;
                  .brg-input__placeholder {
                      color: #909090;
                  }
              }
              &:hover {
                  border-color: #30363A;
                  .brg-input__placeholder {
                      color: #909090 !important;
                  }
              }
  
      }
  
      .brg-input__multi-value__label, .brg-input__single-value  {
          color: #151514 !important;
      }
  
      .brg-input__multi-value {
          background-color: transparent;
          padding-top: 8px;
          svg path {
              fill: #151514;
              cursor: pointer;
          }
      }
  
      .brg-input__multi-value__remove {
          cursor: pointer;
          &:hover {
              background-color: transparent;
          }
      }
  
      .brg-input__menu-list {
          &::-webkit-scrollbar {
            height: 1px;
            width: 2px;
          }
          &::-webkit-scrollbar-track {
            border-radius: 10px;
            background: ${({theme}) => theme.competition.input.bgActive} !important;
          }
          &::-webkit-scrollbar-thumb {
            background: ${({theme}) => theme.competition.input.inputText} !important;
          }
        }
      
        .brg-input__menu {
          background-color: ${({theme}) => theme.competition.input.bg} !important;
      
          .brg-input__option {
            cursor: pointer;
            color: ${({theme}) => theme.competition.input.inputText} !important;
            svg {
              path {
                fill: ${({theme}) => theme.competition.input.inputText} !important;
              }
            }
          }
          .brg-input__option--is-focused {
            background-color: ${({theme}) => theme.competition.input.bgActive} !important;
          }
          .brg-input__option--is-focused:hover {
            background-color: ${({theme}) => theme.competition.input.bgActive} !important;
          }
        }
  
        .brg-input__indicators {
          align-items: start;
        }
        
        .brg-input__indicator {
          padding-top: 14px;
          margin-right: 0;
          svg {
            path {
              fill: ${({theme}) => theme.competition.input.inputText} !important;;
            }
          }
        }
  
      input {
          &:disabled {
              color: #909090 !important;
          }
      }
  
      input, textarea {
          background-color: ${Colors.galBlack5} !important;
          border-color: transparent !important;
          color: ${Colors.galBlack47} !important;
          font-size: 15px;
          line-height: 20px;
  
          &:hover {
              border-color: transparent !important;
          }
  
          &::placeholder {
              color: ${Colors.galBlack47} !important;
          }
      }
  
  
      textarea {
          width: 100%;
          min-height: 73px;
          font-family: 'Inter';
          font-style: normal;
          font-weight: 400;
          font-size: 15px !important;
          line-height: 20px !important;
          letter-spacing: -0.02em  !important;
          padding: 16px 45px 21px 24px;
          color: #151514 !important;
          &::-webkit-scrollbar {
              height: 1px;
              width: 2px;
            }
            &::-webkit-scrollbar-track {
              border-radius: 10px;
              background-color: transparent;
            }
            &::-webkit-scrollbar-thumb {
              background-color: ${({ theme }) => theme.app?.backgroundColor === '#FEFEFE' ? `${Colors.geoWhite47}` : `${Colors.geoWhite100}`};
            }
      }
  
      input {
          height: 48px !important;
          width: 100%;
          font-family: 'Inter';
          font-style: normal;
          font-weight: 400;
          font-size: 15px;
          line-height: 20px;
          letter-spacing: -0.02em;
          color: #151514 !important;
      }

          @media(max-width: ${LayoutConst.screen.md}px) {

          }
  
          @media(max-width: ${LayoutConst.screen.s}px) {
              width: 100%;
              max-width: 100%;
              min-width: 100%;
              input {
                  height: 48px !important;
                width: 100%;
                max-width: 100%;
                min-width: 100%;
              }

              textarea {
                width: 100%;
                max-width: 100%;
                min-width: 100%;
              }
  
              button {
                  font-size: 13px;
                  line-height: 16px;
              }
  
            }
   
      @media(max-width: ${LayoutConst.screen.md}px) {
          input {
              height: 40px !important;
          }
      }
  
      @media(max-width: ${LayoutConst.screen.s}px) {
          input {
              height: 48px !important;
          }
      }
`;

const DEFAULT_VALUE = {
  value: '',
  index: 0
}

interface BilingualTextInputProps extends WrappedFieldProps {
  label: string;
  required?: boolean;
  multiline?: boolean;
  maxLength?: number;
  multipleValues?: boolean;
  hint?: string;
  placeholder: string;
  defaultValue?: string;
  style?: React.CSSProperties;
}

const BaseInput: FC<{
  value: any, 
  onChange: (val: any) => void, 
  placeholder: string, 
  maxLength?: number, 
  required?: boolean
}> = ({ 
  value, 
  onChange, 
  placeholder, 
  maxLength, 
  required 
}) => {

  return (
      <Input.Text
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        maxLength={maxLength}
        required={required}
      />
    )
}

const TextInput: FC<BilingualTextInputProps> = ({
  input,
  input: {
    onChange,
    value: inputValue,
  },
  meta: {
    touched,
    error,
  },
  hint,
  label,
  required,
  multiline,
  multipleValues,
  maxLength,
  placeholder,
  defaultValue,
  style,
  ...rest
}) => {
  const isMobile = useIsMobile();
  const isCompetition = !!useRouteMatch('/competition');
  const [multipleValueIdx, setMultipleValueIdx] = useState([
    {
      value: '',
      index: 0
    }
  ]);

  const handleChange = useCallback(({ target: { value } }: React.BaseSyntheticEvent, index?: number) => {
    const convertValue = value.trimLeft();

    if (multipleValues && Utils.isNumber(index)) {
      const data = [...multipleValueIdx]
      data[index] = {
        index,
        value: convertValue
      }

      setMultipleValueIdx(data);
      onChange(data?.map((v) => v?.value));
      return;
    }

    onChange(convertValue);
  }, [inputValue, multipleValueIdx, multipleValues]);

  const renderInputs = () => {
    return multipleValueIdx?.map((input, index) => {
      return (
        <BaseInput 
          value={input?.value}
          onChange={(ev) => handleChange(ev, index)}
          placeholder={placeholder}
          maxLength={maxLength}
          required={required}
        />
      )
    })
  }

  const multipleValuesComponent = useMemo(() => {
    return (
      <FlexBox 
        direction="column" 
        directionMobile="column" 
        gy={16} 
        offsetBottom={multipleValueIdx?.length > 1 ? 24 : 1}
      >
        {renderInputs()}
        {multipleValueIdx?.length < 3 && (
          <ProjectAddButton
            text={''}
            onClick={() => {
              if (multipleValueIdx?.length < 3) {
                setMultipleValueIdx(
                  [
                    ...multipleValueIdx, 
                    {
                      ...DEFAULT_VALUE, 
                      index: multipleValueIdx?.length + 1
                    }
                  ]
                )
              }
            }} 
          />
        )}
      </FlexBox>
    )
  } , [multipleValueIdx])

  return (
    <GridRow isTeamEdit>
      <FormLabel isTeamEdit>
        <FormLabelText required={isCompetition && required}>{label}</FormLabelText>
        {hint && (
          <InfoIcon stc={isCompetition} isCompetition={isCompetition} msg={hint}/>
        )}
        {required && !isCompetition && (
          <LabelRedStar>*</LabelRedStar>
        )}
      </FormLabel>
      <InputContainer className="input-container" direction="column" directionMobile="column">

        {multipleValues ? multipleValuesComponent : multiline ?
          (
            <>
              <Input.Textarea
                maxLength={maxLength}
                value={defaultValue || inputValue}
                onChange={handleChange}
                style={style}
                placeholder={placeholder}
                required={required}
              />
              <TextAreaLengthCounter 
                value={inputValue?.length}
                pos={{ bottom: 8, right: isMobile ? 16 : 8 }}
                maxLength={maxLength}
              />
            </>
          ) : (
            <Input.Text
              value={defaultValue || inputValue}
              onChange={handleChange}
              placeholder={placeholder}
              maxLength={maxLength}
              required={required}
            />
          )}
      </InputContainer>
    </GridRow>
  )
}

export default TextInput;